import { Link, useNavigate } from "react-router-dom";
import { FaFileMedical, FaPlus } from "react-icons/fa";

const MedicalRecordsEmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="rounded-2xl bg-primary-fixed/10 py-10 px-3 sm:px-8 text-center mt-4">
      <div className="bg-surface-lowest rounded-2xl shadow-sm border border-surface-container max-w-sm mx-auto p-6 mb-8">
        <p className="text-sm font-bold text-primary mb-4">No Records Yet</p>
        <div className="relative flex items-center justify-center py-4">
          <FaFileMedical className="text-primary text-6xl opacity-90" />
          <span className="absolute -top-1 right-1/4 w-3 h-3 rounded-full bg-primary-fixed/60" />
          <span className="absolute bottom-2 left-1/4 w-2 h-2 rounded-full bg-primary-fixed/40" />
        </div>
        <p className="text-xs text-on-surface-variant mt-2 leading-relaxed">
          Your medical history will appear here once added by your provider.
        </p>
      </div>

      <h2 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var mb-2">Zero records uploaded</h2>
      <p className="text-sm text-on-surface-variant mb-8 max-w-md mx-auto leading-relaxed">
        No health records found yet. Upload your first prescription or report to get started.
      </p>

      <button
        type="button"
        onClick={() => navigate("/medicalrecord/upload")}
        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-3 min-h-[48px] rounded-full font-semibold text-sm hover:bg-primary-container transition-colors mb-4"
      >
        <FaPlus size={12} />
        Upload Record
      </button>
      <div>
        <Link to="/privacyandpolicy" className="text-primary font-semibold text-sm hover:underline">
          Learn more about secure storage
        </Link>
      </div>
    </div>
  );
};

export default MedicalRecordsEmptyState;
